<iframe *ngIf="fileExtension == 'pdf'" class="custom-frame" #frames width="100%" height="100%" id="frames" name="frames"
        frameborder="0" [src]="url"></iframe>

<img *ngIf="['jpg','jpeg','gif'].includes(fileExtension)" class="co-file pdf-icon" [src]="demoEndpoints"/>

<embed [src]="url" *ngIf="fileExtension == 'txt'" style="width: 800px; height: 800px;">

<div class="popup-video aa" *ngIf="fileExtension == 'mp4' || 'mp3'">
  <div class="popup-video-display">
    <video controls autoplay class="popup-video-display-source" *ngIf="fileExtension == 'mp4'">
      <source [src]="url" type="video/mp4">
    </video>
    <audio controls autoplay class="popup-video-display-source" *ngIf="fileExtension == 'mp3'">
      <source [src]="url" type="audio/mpeg">
      Your browser does not support the audio element.
    </audio>
  </div>
</div>
